import React, { useState } from "react";
import Sidebar from "../sidebar/sidebar";
import Header from "../header/header";
import { PermissionMenuContext } from "../../contextApi/permissionBasedMenuContext";

const AccessDenied = (props) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const handleSidebarToggle = (isOpen) => setSidebarExpanded(isOpen);

  return (
    <PermissionMenuContext.Consumer>
      {() => (
        <div
          className="d-flex flex-row mainclass"
          style={{ height: "100vh", overflow: "auto", backgroundColor: "#f4f7f6" }}
        >
          <div
            style={{
              flex: sidebarExpanded ? "0 0 21%" : "0 0 60px",
              position: "sticky",
              top: 0,
              zIndex: 999,
              transition: "flex 0.3s ease",
            }}
          >
            <Sidebar
              dataFromParent={props?.location?.pathname || "/home"}
              onSidebarToggle={handleSidebarToggle}
            />
          </div>

          <div
            style={{
              flex: sidebarExpanded ? "1 1 79%" : "1 1 calc(100% - 60px)",
              transition: "flex 0.3s ease",
              minHeight: "100vh",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div style={{ position: "sticky", top: 0, zIndex: 999 }}>
              <Header />
            </div>

            <div
              className="main_wrapper flex-grow-1 d-flex align-items-center justify-content-center"
              style={{
                width: sidebarExpanded ? "79vw" : "calc(100%)",
                minHeight: "calc(100vh - 70px)",
                padding: "40px"
              }}
            >
              <div
                style={{
                  maxWidth: "550px",
                  width: "100%",
                  textAlign: "center",
                  padding: "40px 30px",
                  borderRadius: "16px",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                  border: "1px solid #eaeaea",
                  fontFamily: "'Outfit', 'Inter', sans-serif"
                }}
              >
                {/* Modern Rich Gradient Locked Icon */}
                <div
                  style={{
                    width: "90px",
                    height: "90px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #ff7b7b 0%, #ff4b4b 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 24px",
                    boxShadow: "0 8px 20px rgba(255, 75, 75, 0.2)"
                  }}
                >
                  <svg
                    width="42"
                    height="42"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#ffffff"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                </div>

                <h2
                  style={{
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#2c3e50",
                    marginBottom: "12px"
                  }}
                >
                  Access Denied
                </h2>

                <p
                  style={{
                    fontSize: "16px",
                    color: "#7f8c8d",
                    lineHeight: "1.6",
                    marginBottom: "28px"
                  }}
                >
                  You do not have permission to view this page. If you believe this is an error, please contact your administrator.
                </p>

                <button
                  onClick={() => window.history.back()}
                  style={{
                    padding: "12px 28px",
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#ffffff",
                    background: "linear-gradient(135deg, #3F88A5 0%, #2a6882 100%)",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    boxShadow: "0 4px 15px rgba(63, 136, 165, 0.25)",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease"
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(63, 136, 165, 0.35)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "none";
                    e.currentTarget.style.boxShadow = "0 4px 15px rgba(63, 136, 165, 0.25)";
                  }}
                >
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </PermissionMenuContext.Consumer>
  );
};

export default AccessDenied;
